import React from "react";
import { Quote, Check } from "lucide-react";
import { philosophy, doctor } from "../mock";
import Reveal from "./Reveal";

const Philosophy = () => {
  return (
    <section id="philosophy" className="bg-navy text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(191,157,87,0.10), transparent 70%)" }} />
      <div className="max-w-6xl mx-auto px-4 py-20 grid lg:grid-cols-2 gap-12 items-center relative">
        <Reveal>
          <div className="relative">
            <div className="absolute -inset-3 rounded-3xl border border-gold/30" />
            <img src={doctor.scrubs} alt={doctor.name} className="relative w-full max-w-md mx-auto rounded-3xl object-cover shadow-2xl" />
          </div>
        </Reveal>

        <Reveal delay={1}>
          <Quote className="w-14 h-14 text-gold/50 mb-4" />
          <h2 className="font-head text-4xl sm:text-5xl font-bold leading-tight text-white">
            {"\u201c" + philosophy.quote + "\u201d"}
          </h2>
          <div className="w-16 h-0.5 bg-gold my-8" />
          <ul className="space-y-4">
            {philosophy.points.map((p) => (
              <li key={p} className="flex items-center gap-3 text-lg text-white/80">
                <span className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center shrink-0">
                  <Check className="w-4 h-4 text-gold" />
                </span>
                {p}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default Philosophy;
